import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { designTokens } from '@/styles/designTokens'
import { FaKey, FaSignInAlt } from 'react-icons/fa'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  border: 2px solid #4a90e2;
`;

const Title = styled.h1`
  color: white;
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const Subtitle = styled.p`
  color: #b8d4f8;
  font-size: 1.2rem;
  margin-bottom: 30px;
  line-height: 1.5;
`;

const InputContainer = styled.div`
  margin: 30px 0;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px 20px;
  font-size: 1.2rem;
  border: 2px solid #4a90e2;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  text-align: center;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;
  
  &::placeholder {
    color: #b8d4f8;
  }
  
  &:focus {
    outline: none;
    border-color: #7bb3f0;
    box-shadow: 0 0 15px rgba(74, 144, 226, 0.3);
  }
`;

const Button = styled.button`
  background: linear-gradient(45deg, #4a90e2, #7bb3f0);
  color: white;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  margin: 10px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(74, 144, 226, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid #ff6b6b;
  border-radius: 8px;
  padding: 10px;
  margin: 15px 0;
  font-size: 0.9rem;
`;

const SuccessMessage = styled.div`
  color: #51cf66;
  background: rgba(81, 207, 102, 0.1);
  border: 1px solid #51cf66;
  border-radius: 8px;
  padding: 10px;
  margin: 15px 0;
  font-size: 0.9rem;
`;

const AuthModal = ({ isVisible, onAuthSuccess, onClose }) => {
  const [inputCode, setInputCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setInputCode('');
      setError('');
      setSuccess('');
    }
  }, [isVisible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!inputCode.trim()) {
      setError('Por favor, insira o código de autorização');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      // Apenas envia o código digitado
      await onAuthSuccess(inputCode.trim());
    } catch (err) {
      setError('Erro ao verificar código. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isVisible) return null;

  return (
    <ModalOverlay>
      <ModalContent style={{ position: 'relative' }}>
        <Title>🔐 Autenticação</Title>
        <Subtitle>
          Digite o código de autorização fornecido pelo administrador para conectar-se a aplicação.
        </Subtitle>
        <form onSubmit={handleSubmit}>
          <InputContainer>
            <Input
              type="text"
              placeholder="Digite o código de autorização"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value.toUpperCase())}
              maxLength={16}
              autoFocus
              disabled={isLoading}
            />
          </InputContainer>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {success && <SuccessMessage>{success}</SuccessMessage>}
          <div>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Verificando...' : 'Autorizar'}
            </Button>
          </div>
        </form>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AuthModal; 